export default __webpack_public_path__ + "static/genesis_commander_logo-b6997daac305299cde082985c6800dab.png";